import React from 'react'
import PropTypes from 'prop-types'
import { ListItem, ListItemText, useMediaQuery, useTheme } from '@mui/material'
import { get } from 'lodash'
import Grid from '@mui/material/Grid'
import { createDateFromString, formatDateToFEFormatDateFns } from 'utils/date'
import InvoiceStatusChip from 'components/common/chip/InvoiceStatusChip'

const PartialPaidInvoiceRenderCell = ({ row }) => {
  const invoiceNumber = get(row, 'invoiceNumber')
  const accountNumber = get(row, 'accountNumber')
  const customerName = get(row, 'customerName') || get(row, 'accountName')
  const balanceCents = get(row, 'balanceCents')
  const dueDateStr = get(row, 'dueDate')
  const status = get(row, 'status')
  const dueDateObj = createDateFromString(dueDateStr)
  const dueDate = formatDateToFEFormatDateFns(dueDateObj)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  if (isMobile) {
    return (
      <ListItem
        secondaryAction={
          <InvoiceStatusChip size="small" status={status} isPartial={balanceCents !== 0} showAmount amountCents={balanceCents} />
        }
      >
        <ListItemText
          primary={`#${invoiceNumber}`}
          secondary={customerName}
          slotProps={{
            primary: {
              variant: 'h6',
              color: 'textPrimary',
              gutterBottom: true,
            },

            secondary: {
              variant: 'body1',
            },
          }}
        />
      </ListItem>
    )
  }

  return (
    <Grid container sx={{ width: '100%' }}>
      <Grid size="grow">
        <ListItem>
          <ListItemText
            primary={`#${invoiceNumber}`}
            secondary={`${accountNumber} | ${customerName}`}
            slotProps={{
              primary: {
                variant: 'h6',
                color: 'textPrimary',
                gutterBottom: true,
              },

              secondary: {
                variant: 'body1',
              },
            }}
          />
        </ListItem>
      </Grid>
      <Grid size="grow">
        <ListItem>
          <ListItemText
            primary={
              <InvoiceStatusChip size="small" status={status} isPartial={balanceCents !== 0} showAmount amountCents={balanceCents} />
            }
            secondary={`DUE: ${dueDate}`}
            slotProps={{
              primary: {
                textAlign: 'right',
                variant: 'h6',
              },

              secondary: {
                textAlign: 'right',
                sx: {
                  pr: 0.5,
                },
                color: 'textPrimary',
                variant: 'body1',
                fontWeight: 500,
              },
            }}
          />
        </ListItem>
      </Grid>
    </Grid>
  )
}

PartialPaidInvoiceRenderCell.propTypes = {
  row: PropTypes.object,
}

export default PartialPaidInvoiceRenderCell
